import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";

import { login, loginNumber, signFailed } from "../../redux/actions/auth";

import { Link, useHistory } from "react-router-dom";
import TextField from "@mui/material/TextField";
import Swal from "sweetalert2";

import { toast, ToastContainer } from "react-toastify";
import LoginLoader from "../../components/LoginLoader";

import { ThemeProvider, createTheme, Backdrop } from "@mui/material";
import { useFormik } from "formik";
import * as yup from "yup";
import { xCheckSumIdGernator } from "../../helper/helper";
import axios from "axios";
import Loader from "../../components/Loader";

const customId1 = "custom-id-yess";

function SignUpNumber(props) {
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [isOpenOtp, setIsOpenOtp] = useState(true);
  const [value, setValue] = React.useState(0);

  const [signType, setSignType] = useState(true);

  const theme = createTheme({
    components: {
      MuiFormLabel: {
        styleOverrides: {
          asterisk: { color: "red" },
        },
      },
    },
  });

  const dispatch = useDispatch();

  const signuppp = () => {
    setSignType(false);
  };

  const resetSTATE = () => {
    dispatch(signFailed());
  };

  const validationSchema = yup.object({
    username: yup
      .number("Enter your Phone Number")
      // .email("E-Mail must be valid")
      .required("Phone Number is required")
      .max(
        1000000000000,
        "Phone Number should be of maximum 11 characters length"
      )
      .min(
        1000000000,
        "Phone Number should be of minimum 10 characters length"
      ),
  });

  const validationSchema1 = yup.object({
    otp: yup
      .number("Enter your OTP")
      .required("OTP is required")
      .min(1000, "OTP should be of minimum 4 characters length")
      .max(1000000, "OTP should be of minimum 6 characters length"),
  });

  const formik = useFormik({
    initialValues: {
      username: "",
    },

    onReset: (initialValues) => ({
      values: { initialValues },
    }),

    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        setOpen(true);
        const xCheckSumValues = xCheckSumIdGernator(values.username);
        const res = await axios.post(
          "http://192.168.167.66:5001/auth/v1/pin/generate",

          {
            // msisdn: Number(parseData.mobile),
            msisdn: values.username,
            requestId: xCheckSumValues.generator,
            isDebug: false,
          },
          {
            headers: {
              "X-CHECKSUM-ID": xCheckSumValues.allValuesHashed,
            },
          }
        );
        if (res.data.statusDescription.statusCode == 200) {
          setOpen(false);
          localStorage.setItem("transactionId", res.data.transactionId);
          localStorage.setItem("msisdn", res.data.msisdn);
          // await toast.success("Otp Sent Successfully", {
          //   theme: "colored",
          //   customId1,
          // });
          Swal.fire({
            icon: "success",
            // title: "Oops...",
            text: "Otp Sent Successfully",
            // footer: '<a href="">Why do I have this issue?</a>'
          });
          setIsOpenOtp(false);
        } else {
          setOpen(false);
          // await toast.error(res.data.statusDescription.description, {
          //   theme: "colored",
          //   customId1,
          // });
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusDescription.description,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      } catch (error) {
        // console.log(error);

        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
        setOpen(false);
      }
    },
  });

  const formik1 = useFormik({
    initialValues: {
      otp: "",
    },

    onReset: (initialValues) => ({
      values: { initialValues },
    }),

    validationSchema: validationSchema1,
    onSubmit: async (values) => {
      try {
        return props.loginNumber(values.otp);
      } catch (error) {
        // console.log(error);

        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    },
  });

  return (
    <>
      <ToastContainer autoClose={5000} />
      <ThemeProvider theme={theme}>
        <main className="main-content  mt-0">
          <Backdrop
            sx={{
              transform: "translateZ(0)",
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={open}
            // onClick={handleClose}
          >
            <Loader />
          </Backdrop>

          <div className="page-header align-items-start min-vh-100">
            <span className="mask bg-gradient-dark opacity-6"></span>
            <div className="container my-auto">
              <div className="row">
                <div className="col-lg-4 col-md-8 col-12 mx-auto">
                  <div className="card z-index-0 fadeIn3 fadeInBottom card_1">
                    <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                      <div className="bg-gradient-primary shadow-primary border-radius-lg py-3 pe-1">
                        <h4 className="text-white font-weight-bolder text-center mt-2 mb-0">
                          Log in
                        </h4>
                      </div>
                    </div>
                    <div className="card-body">
                      {isOpenOtp ? (
                        <form
                          className="text-start"
                          onSubmit={formik.handleSubmit}
                        >
                          <div className="input-group input-group-outline mb-4">
                            <TextField
                              required
                              className="w-100"
                              label="Phone number"
                              name="username"
                              type="number"
                              variant="outlined"
                              size="small"
                              onInput={(e) => {
                                e.target.value = Math.max(
                                  0,
                                  parseInt(e.target.value)
                                )
                                  .toString()
                                  .slice(0, 10);
                              }}
                              value={formik.values.username}
                              onChange={formik.handleChange}
                              error={
                                formik.touched.username &&
                                Boolean(formik.errors.username)
                              }
                              helperText={
                                formik.touched.username &&
                                formik.errors.username
                              }
                            />
                          </div>

                          <div className="text-center">
                            <button
                              className="btn bg-gradient-primary w-100 my-4 mb-2"
                              type="submit"
                            >
                              Send OTP
                            </button>
                          </div>
                          <p className="mt-4 text-sm text-end">
                            <button
                              type="reset"
                              onClick={formik.resetForm}
                              value="reset"
                              className="text-primary text-gradient font-weight-bold"
                              style={{ border: "none" }}
                            >
                              Reset
                            </button>
                          </p>
                        </form>
                      ) : (
                        <form
                          className="text-start"
                          onSubmit={formik1.handleSubmit}
                        >
                          <div className="input-group input-group-outline mb-4">
                            <TextField
                              className="w-100"
                              label="Enter OTP"
                              name="otp"
                              type="number"
                              variant="outlined"
                              size="small"
                              autoFocus
                              value={formik1.values.otp}
                              onChange={formik1.handleChange}
                              error={
                                formik1.touched.otp &&
                                Boolean(formik1.errors.otp)
                              }
                              helperText={
                                formik1.touched.otp && formik1.errors.otp
                              }
                            />
                          </div>

                          <div className="text-center">
                            <button
                              className="btn bg-gradient-primary w-100 my-4 mb-2"
                              type="submit"
                            >
                              Verify OTP & Log in
                            </button>
                          </div>

                          <p className="mt-4 text-sm text-end">
                            <button
                              type="reset"
                              onClick={formik1.resetForm}
                              value="reset"
                              className="text-primary text-gradient font-weight-bold"
                              style={{ border: "none" }}
                            >
                              Reset
                            </button>
                          </p>
                        </form>
                      )}
                      <p className="mt-4 text-sm text-end">
                        <Link to="/forgotpassword">
                          <button
                            type="button"
                            value="reset"
                            className="text-primary text-gradient font-weight-bold"
                            style={{ border: "none" }}
                          >
                            Forgot Password?
                          </button>
                        </Link>
                      </p>

                      <Link to="/">
                        <p className="mt-4 text-sm text-end">
                          <button
                            type="reset"
                            value="reset"
                            className="text-primary text-gradient font-weight-bold"
                            style={{ border: "none" }}
                          >
                            Login With Username
                          </button>
                        </p>
                      </Link>

                      <Link to="/SignUp">
                        <p className="mt-4 text-sm text-end">
                          <button
                            type="button"
                            value="reset"
                            onClick={() => {
                              signuppp();
                              resetSTATE();
                            }}
                            className="text-primary text-gradient font-weight-bold"
                            style={{ border: "none" }}
                          >
                            Don't Have an account ? Sign Up
                          </button>
                        </p>
                      </Link>

                      <LoginLoader visible={props.loading} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </ThemeProvider>
    </>
  );
}

const mapStateToProps = (state) => ({
  loading: state.authReducer.loading,
});

const mapDispatchToProps = (dispatch) => ({
  loginNumber: (otp) => dispatch(loginNumber(otp)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignUpNumber);
